import {
    Component,
    OnInit,
    Injector,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
import { DataTable } from "primeng/components/datatable/datatable";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { LazyLoadEvent } from "primeng/components/common/lazyloadevent";
import { Paginator } from "primeng/components/paginator/paginator";
import { FileDownloadService } from "@shared/utils/file-download.service";
import {
    RegistrationsServiceProxy,
    EventsServiceProxy,
    CategoryServiceProxy,
    EntityDtoOfInt64,
    UserServiceProxy,
} from "@shared/service-proxies/service-proxies";
import {
    SubscriptionSituationType,
    PaymentChargeStatus,
    StatusIntegracao,
} from "@shared/AppEnums";
import { DisapproveModalComponent } from "@app/event/registrations/modals/disapprove/disapprove-modal.component";
import { CancelModalComponent } from "@app/event/registrations/modals/cancel/cancel-modal.component";
import { TransferToAnotherUserModalComponent } from "@app/event/registrations/modals/transfer-to-another-user/transfer-to-another-user-modal.component";
import { TransferToAnotherEventModalComponent } from "./modals/transfer-to-another-event/transfer-to-another-event-modal.component";
import { VisualizeUserModalComponent } from "@app/admin/users/visualize-user-modal.component";
import { CorreiosService } from "@app/shared/common/correios/correios.service";
import { Router } from "@angular/router";
import { DetailModalComponent } from "@app/event/registrations/modals/detail/detail-modal.component";
import { ImportPresenceToRegistrationsModalComponent } from "@app/event/registrations/modals/import-presence-to-registrations/import-presence-to-registrations-modal.component";

import * as moment from "moment";
import * as _ from "lodash";

@Component({
    templateUrl: "./registrations.component.html",
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class RegistrationsComponent extends AppComponentBase implements OnInit {
    subscriptionSituationType = SubscriptionSituationType;
    paymentChargeStatus = PaymentChargeStatus;
    statusIntegracao = StatusIntegracao;

    @ViewChild("importPresenceToRegistrationsModal")
    importPresenceToRegistrationsModal: ImportPresenceToRegistrationsModalComponent;
    @ViewChild("visualizeUserModal")
    visualizeUserModal: VisualizeUserModalComponent;
    @ViewChild("disapproveModal") disapproveModal: DisapproveModalComponent;
    @ViewChild("cancelModal") cancelModal: CancelModalComponent;
    @ViewChild("transferToAnotherUserModal")
    transferToAnotherUserModal: TransferToAnotherUserModalComponent;
    @ViewChild("transferToAnotherEventModal")
    transferToAnotherEventModal: TransferToAnotherEventModalComponent;
    @ViewChild("detailModal") detailModal: DetailModalComponent;

    @ViewChild("dataTable") dataTable: DataTable;
    @ViewChild("paginator") paginator: Paginator;

    //Filters
    filterText = "";
    filterHasPresence = undefined;
    filterAnnuityPaid = undefined;
    filterMemberCategoryId = undefined;
    filterCategoryDeadLineId = undefined;
    filterMemberStatus = undefined;
    filterEvent = undefined;
    filterListEvents = [];
    filterPaymentStatus = undefined;
    filterSituation = undefined;
    filterPaymentBeginDate = undefined;
    filterPaymentEndDate = undefined;
    filterIsResident = undefined;
    filterCountry = undefined;
    filterCountryState = undefined;
    filterCity = undefined;
    filterStatusIntegracao = undefined;
    advancedFiltersAreShown = false;

    events = [];
    categories = [];
    categoriesDeadline = [];
    memberStatusList = [];
    brazilStates: any[] = CorreiosService.loadBrazilStates();
    countries: any[] = CorreiosService.loadCountries();
    citiesFromState = [];
    selectedMembers = [];

    downloadingFile = false;

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy,
        private _eventsService: EventsServiceProxy,
        private _userService: UserServiceProxy,
        private _categoryService: CategoryServiceProxy,
        private _correiosService: CorreiosService,
        private _fileDownloadService: FileDownloadService,
        private _router: Router
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadCategories();
        this.loadMemberStatus();
    }

    ngAfterViewChecked(): void {
        $(".datetimepicker").datetimepicker({
            locale: abp.localization.currentLanguage.name,
            format: "L",
        });
    }

    getRegistrations(event?: LazyLoadEvent) {
        if (this.primengDatatableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);

            return;
        }

        if (!this.filterPaymentBeginDate && this.filterPaymentEndDate) {
            this.message.warn(
                this.l(
                    "You must select {0} in Advanced Filters.",
                    this.l("Begin Payment Date")
                )
            );
        } else if (this.filterPaymentBeginDate && !this.filterPaymentEndDate) {
            this.message.warn(
                this.l(
                    "You must select {0} in Advanced Filters.",
                    this.l("End Payment Date")
                )
            );
        } else if (
            this.filterPaymentBeginDate &&
            this.filterPaymentEndDate &&
            this.filterPaymentBeginDate.diff(this.filterPaymentEndDate) > 0
        ) {
            this.message.warn(
                this.l(
                    "The {0} must be bigger than {1} in Advanced Filters.",
                    this.l("End Payment Date"),
                    this.l("Begin Payment Date")
                )
            );
        } else {
            this.selectedMembers = [];
            this.primengDatatableHelper.showLoadingIndicator();
            let eventIds = _.map(this.filterListEvents, (selected) =>
                Number(selected.id)
            );

            this._registrationsService
                .getAll(
                    this.filterText,
                    this.filterHasPresence,
                    this.filterAnnuityPaid,
                    this.filterMemberCategoryId,
                    this.filterCategoryDeadLineId,
                    this.filterMemberStatus
                        ? this.filterMemberStatus.id
                        : undefined,
                    this.filterEvent ? this.filterEvent.id : undefined,
                    eventIds,
                    this.filterPaymentStatus,
                    this.filterSituation,
                    this.filterStatusIntegracao,
                    this.filterPaymentBeginDate,
                    this.filterPaymentEndDate,
                    this.filterIsResident,
                    this.filterCountry,
                    this.filterCountryState,
                    this.filterCity,
                    this.selectedMembers,
                    this.primengDatatableHelper.getSorting(this.dataTable),
                    this.primengDatatableHelper.getSkipCount(
                        this.paginator,
                        event
                    ),
                    this.primengDatatableHelper.getMaxResultCount(
                        this.paginator,
                        event
                    )
                )
                .finally(() => {
                    this.primengDatatableHelper.hideLoadingIndicator();
                })
                .subscribe((result) => {
                    this.primengDatatableHelper.totalRecordsCount =
                        result.totalCount;
                    this.primengDatatableHelper.records = result.items;
                });
        }
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    clear(): void {
        this.filterText = "";
        this.filterHasPresence = undefined;
        this.filterAnnuityPaid = undefined;
        this.filterMemberCategoryId = undefined;
        this.filterCategoryDeadLineId = undefined;
        this.filterMemberStatus = undefined;
        this.filterEvent = undefined;
        this.filterListEvents = [];
        this.filterPaymentStatus = undefined;
        this.filterSituation = undefined;
        this.filterPaymentBeginDate = undefined;
        this.filterPaymentEndDate = undefined;
        this.filterIsResident = undefined;
        this.filterCountry = undefined;
        this.filterCountryState = undefined;
        this.filterCity = undefined;
    }

    loadCategoriesEvent(eventIsOnBlur?: boolean): void {
        if (eventIsOnBlur && this.filterListEvents.length == 1) return null;

        this.categoriesDeadline = [];
        this.filterCategoryDeadLineId = undefined;

        if (this.filterListEvents.length > 0) {
            this._eventsService
                .getCategoryDeadlines(
                    undefined,
                    this.filterListEvents[0].id,
                    true
                )
                .subscribe((result) => {
                    this.categoriesDeadline = result.items;
                });
        }
    }

    // Update Begin Payment Date Filter
    upadateFilterPaymentBeginDate(value: string) {
        this.filterPaymentBeginDate = value ? moment(value, "L") : undefined;
    }

    // Update End Payment Date Filter
    upadateFilterPaymentEndDate(value: string) {
        this.filterPaymentEndDate = value ? moment(value, "L") : undefined;
    }

    // Load Categories User
    loadCategories() {
        this._categoryService
            .getForSelect("", undefined, true, false)
            .subscribe((result) => {
                this.categories = result.items;
            });
    }

    // Load Member Status User
    loadMemberStatus(): void {
        this._userService
            .getMemberStatusForSelect(undefined)
            .subscribe((result) => {
                this.memberStatusList = result.items;
            });
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService
            .getEventsForSelect(
                event.query,
                0,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                10,
                0
            )
            .subscribe((result) => {
                this.events = result.items;
            });
    }

    // Check Country Name Is Brasil
    isBrasil(): boolean {
        return this.filterCountry == "BRASIL";
    }

    // Clear State And City
    clearStateAndCity() {
        this.filterCountryState = undefined;
        this.citiesFromState = [];
        this.filterCity = undefined;
    }

    // Load Cities
    loadCities() {
        this.citiesFromState = [];
        this.filterCity = undefined;

        if (this.filterCountryState) {
            this._correiosService
                .loadCities(this.filterCountryState)
                .then((cities) => {
                    this.citiesFromState = cities;
                });
        }
    }

    // Set Presence
    setPresence(registration: any): void {
        let inputSetPresence = new EntityDtoOfInt64();
        inputSetPresence.id = registration.id;

        let msg = this.l("Are you sure confirm presence?");

        this.message.confirm(msg, (isConfirmed) => {
            if (isConfirmed) {
                this._registrationsService
                    .setPresence(inputSetPresence)
                    .subscribe(() => {
                        this.reloadPage();
                        this.notify.success(this.l("SavedSuccessfully"));
                    });
            }
        });
    }

    deletePresence(registration: any) {
        let inputSetPresence = new EntityDtoOfInt64();
        inputSetPresence.id = registration.id;

        let msg = this.l("Are you sure delete presence?");

        this.message.confirm(msg, (isConfirmed) => {
            if (isConfirmed) {
                this._registrationsService
                    .deletePresence(registration.id)
                    .subscribe(() => {
                        this.reloadPage();
                        this.notify.success(this.l("SavedSuccessfully"));
                    });
            }
        });
    }

    // Approve
    approve(registration: any): void {
        let msg = this.l(
            "Are you sure approve the registration of the {0}?",
            registration.user.name
        );

        let inputApprove = new EntityDtoOfInt64();
        inputApprove.id = registration.id;

        this.message.confirm(msg, (isConfirmed) => {
            if (isConfirmed) {
                this._registrationsService
                    .approve(inputApprove)
                    .subscribe(() => {
                        this.reloadPage();
                        this.notify.success(this.l("SavedSuccessfully"));

                        let inputRegistrationApproved = new EntityDtoOfInt64();
                        inputRegistrationApproved.id = registration.id;
                        if (
                            registration.categoryDeadLine.description !=
                                "Palestrante" &&
                            registration.categoryDeadLine.description !=
                                "palestrante" &&
                            registration.categoryDeadLine.description !=
                                "Palestrantes" &&
                            registration.categoryDeadLine.description !=
                                "palestrantes"
                        ) {
                            this._registrationsService
                                .sendRegistrationApprovedEmail(
                                    inputRegistrationApproved
                                )
                                .subscribe(() => {
                                    this.reloadPage();
                                    this.message.success(
                                        this.l(
                                            "The registration approved have been sent by email."
                                        )
                                    );
                                });
                        }
                    });
            }
        });
    }

    // Send Registration Approved By Email
    sendRegistrationApprovedEmail(registration: any): void {
        let msg = this.l("Are you sure send registration approved by email?");

        let inputRegistrationApproved = new EntityDtoOfInt64();
        inputRegistrationApproved.id = registration.id;

        this.message.confirm(msg, (isConfirmed) => {
            if (isConfirmed) {
                this._registrationsService
                    .sendRegistrationApprovedEmail(inputRegistrationApproved)
                    .subscribe(() => {
                        this.reloadPage();
                        this.message.success(
                            this.l(
                                "The registration approved have been sent by email."
                            )
                        );
                    });
            }
        });
    }

    // Export Registrations to Excel
    exportToExcel(): void {
        if (this.primengDatatableHelper.totalRecordsCount > 7000) {
            this.message.warn(this.l("ExportLimitMessage", "7000"));
        } else {
            this.downloadingFile = true;
            let registrationIds = _.map(
                this.selectedMembers,
                (selectedCharge) => Number(selectedCharge.registration.id)
            );
            let eventIds = _.map(this.filterListEvents, (selected) =>
                Number(selected.id)
            );

            this._registrationsService
                .getRegistrationsToExcel(
                    this.filterText,
                    this.filterHasPresence,
                    this.filterAnnuityPaid,
                    this.filterMemberCategoryId,
                    this.filterCategoryDeadLineId,
                    this.filterMemberStatus
                        ? this.filterMemberStatus.id
                        : undefined,
                    this.filterEvent ? this.filterEvent.id : undefined,
                    eventIds,
                    this.filterPaymentStatus,
                    this.filterSituation,
                    this.filterStatusIntegracao,
                    this.filterPaymentBeginDate,
                    this.filterPaymentEndDate,
                    this.filterIsResident,
                    this.filterCountry,
                    this.filterCountryState,
                    this.filterCity,
                    registrationIds
                )
                .finally(() => {
                    this.downloadingFile = false;
                })
                .subscribe((result) => {
                    this.selectedMembers = [];
                    this._fileDownloadService.downloadTempFile(result);
                });
        }
    }

    getCredentials(): void {
        let registrationIds: number[] = _.map(
            this.selectedMembers,
            (selectedCharge) => Number(selectedCharge.registration.id)
        );
        let eventIds = _.map(this.filterListEvents, (selected) =>
            Number(selected.id)
        );

        if (registrationIds.length == 0 && eventIds.length == 0) {
            this.message.warn(
                this.l(
                    "You must select the Registrations or select the Events in Advanced Filters."
                )
            );
        } else {
            this.downloadingFile = true;

            this._registrationsService
                .getCredentials(
                    true,
                    this.filterText,
                    this.filterHasPresence,
                    this.filterAnnuityPaid,
                    this.filterMemberCategoryId,
                    this.filterCategoryDeadLineId,
                    this.filterMemberStatus
                        ? this.filterMemberStatus.id
                        : undefined,
                    this.filterEvent ? this.filterEvent.id : undefined,
                    eventIds,
                    this.filterPaymentStatus,
                    this.filterSituation,
                    this.filterStatusIntegracao,
                    this.filterPaymentBeginDate,
                    this.filterPaymentEndDate,
                    this.filterIsResident,
                    this.filterCountry,
                    this.filterCountryState,
                    this.filterCity,
                    registrationIds
                )
                .finally(() => {
                    this.downloadingFile = false;
                })
                .subscribe((result) => {
                    this.selectedMembers = [];
                    this._fileDownloadService.downloadTempFile(result);
                });
        }
    }

    getTickets() {
        let registrationIds: number[] = _.map(
            this.selectedMembers,
            (selectedCharge) => Number(selectedCharge.registration.id)
        );
        let eventIds = _.map(this.filterListEvents, (selected) =>
            Number(selected.id)
        );

        if (registrationIds.length == 0 && eventIds.length == 0) {
            this.message.warn(
                this.l(
                    "You must select the Registrations or select the Events in Advanced Filters."
                )
            );
        } else {
            this.message.confirm(
                this.l(
                    "Only the users mark as Correspondence in Addresses and not mark as Deceased in User Informations will be available."
                ),
                (isConfirmed) => {
                    if (isConfirmed) {
                        this.downloadingFile = true;

                        this._registrationsService
                            .getUserAddressTags(
                                this.filterText,
                                this.filterHasPresence,
                                this.filterAnnuityPaid,
                                this.filterMemberCategoryId,
                                this.filterCategoryDeadLineId,
                                this.filterMemberStatus
                                    ? this.filterMemberStatus.id
                                    : undefined,
                                this.filterEvent
                                    ? this.filterEvent.id
                                    : undefined,
                                eventIds,
                                this.filterPaymentStatus,
                                this.filterSituation,
                                this.filterStatusIntegracao,
                                this.filterPaymentBeginDate,
                                this.filterPaymentEndDate,
                                this.filterIsResident,
                                this.filterCountry,
                                this.filterCountryState,
                                this.filterCity,
                                registrationIds
                            )
                            .finally(() => {
                                this.downloadingFile = false;
                            })
                            .subscribe((result) => {
                                this.selectedMembers = [];
                                this._fileDownloadService.downloadTempFile(
                                    result
                                );
                            });
                    }
                }
            );
        }
    }

    showMotiveDisapprove(motiveDisapprove: string) {
        this.message.warn(motiveDisapprove, this.l("Motive Disapprove"));
    }

    goToRegistrationByAdmin() {
        setTimeout(() => {
            this._router.navigate(["app/event/registration"], {
                queryParams: { admin: true },
            });
        }, 0);
    }

    importRegistrations() {
        this.importPresenceToRegistrationsModal.show();
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/registrations.component.ts